(() => {
  const root = document.querySelector('[data-jf-amazon-redirect]');
  if (!root || window.Shopify?.designMode || window.__jfAmazonRedirect) return;
  const anchor = root.querySelector('a[data-amazon-destination]');
  if (!anchor) return;

  let destination;
  try {
    destination = new URL(anchor.href, location.href);
  } catch {
    return;
  }
  if (destination.protocol !== 'https:' || !/^(?:www\.)?amazon\.com$/i.test(destination.hostname)) return;
  if (!/^\/dp\/B0HF3871HR\/?$/i.test(destination.pathname)) return;
  window.__jfAmazonRedirect = true;

  let sent = false;
  let finished = false;
  let retry;
  const leave = () => {
    if (finished) return;
    finished = true;
    clearTimeout(retry);
    clearTimeout(deadline);
    location.replace(destination.href);
  };
  const deadline = setTimeout(leave, 2500);

  const send = () => {
    if (finished || sent) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) {
      leave();
      return;
    }
    if (typeof window.gtag !== 'function') {
      retry = setTimeout(send, 50);
      return;
    }
    sent = true;
    window.gtag('event', 'amazon_redirect', {
      send_to: 'G-X8MPYHG7EQ',
      transport_type: 'beacon',
      link_domain: destination.hostname,
      link_url: destination.origin + destination.pathname,
      asin: 'B0HF3871HR',
      brand_path: root.dataset.brandPath,
      event_callback: leave,
      event_timeout: 1500
    });
  };
  send();
})();
